import { Col } from '@rematter/ui-web';
import { LucidePackage } from 'lucide-react';

import { useTranslations } from '../../../i18n/useTranslations';
import { PurchaseLoadRecord } from '../../../types/purchaseLoad';

import { InboundMaterialsEditor } from './InboundMaterialsEditor';

type InboundTicketTabMaterialsProps = {
  ticket: PurchaseLoadRecord | null;
};

//
// ⚛️ ⚛️ ⚛️ INBOUND TICKET TAB MATERIALS ⚛️ ⚛️ ⚛️
//
export const InboundTicketTabMaterials = ({
  ticket,
}: InboundTicketTabMaterialsProps) => {
  const t = useTranslations();

  if (!ticket) {
    return (
      <Col className="@InboundTicketTabMaterials h-full" xCenter yCenter>
        <div className="text-foreground/50">
          {t.scaleTicketPro.noTicketData}
        </div>
      </Col>
    );
  }

  const isEditable = ticket.status !== 'Paid' && ticket.status !== 'Voided';
  const hasNoLineItems = !ticket.lineItems || ticket.lineItems.length === 0;

  if (hasNoLineItems && !isEditable) {
    return (
      <Col
        className="@InboundTicketTabMaterials h-full p-8"
        gap4
        xCenter
        yCenter
      >
        <LucidePackage className="h-12 w-12 text-foreground/30" />
        <Col className="text-center" gap1>
          <div className="text-lg font-medium text-foreground/70">
            {t.scaleTicketPro.noMaterialsAdded}
          </div>
          <div className="text-sm text-foreground/50">
            {t.scaleTicketPro.ticketClosedNoMaterials}
          </div>
        </Col>
      </Col>
    );
  }

  return (
    <div className="@InboundTicketTabMaterials h-full">
      <InboundMaterialsEditor ticket={ticket} disabled={!isEditable} />
    </div>
  );
};
